ACC.tabs = {

	_autoload: [
		["bindTabs", $(".js-tabs").length > 0],
		"hideReviewBtn",
		"determineToDisplayReviews",
		"determineToDisplaySpecifications",
	],

	bindTabs: function(){

		$e = $(".js-tabs");
		$topTabs = $(".product-main-info .product-details");
		var tabs = $e.accessibleTabs({
			tabhead:'.tabhead',
			tabbody: '.tabbody',
			fx:'show',
			fxspeed: 0,
			currentClass: 'active',
			autoAnchor:true
		});

		$(window).resize(function(){
			if($(window).width() >= 640){
				$(".product-desc .product-desc-content").show().parent().addClass("active");
			}
		});

		$topTabs.on("click",".product-desc h2",function(e){
			e.preventDefault();

			if($(window).width() < 640){
				$content = $(this).closest(".product-desc").find(".product-desc-content");
				$(this).toggleClass("active");

				if(!$(this).hasClass("active")){
					// $content.animate({
					// 	scrollTop : $content.height()
					// }, {queue: false, duration: 300});
					$content.slideUp(300);
				} else{
					$content.slideDown(300);
				}
			}
		});

		if(/iPhone|iPad|iPod/i.test(navigator.userAgent) && $(window).width() <= 1024) {
			$e.on("mouseover",".tabs-tab",function(e){
				$(this).trigger("click");
			});
		}

		$e.on("click",".tabhead",function(e){
			e.preventDefault();

			// if($(this).toggleClass("active")){
			// 	$(this).removeClass("active");
			// }else{
			// 	$(this).parents(".js-tabs").children(".tabs-list").find("a[href="+"#"+$(this).attr("id")+"]").click();
			//
			// 	// var offset = $(this).position().top;
			// 	// $("body,html").scrollTop(offset)
			// }

			$(this).toggleClass("active");

		});

		$e.on("click","#tabreview",function(e){
			e.preventDefault();
			ACC.tabs.showReviewsAction("reviews");
			ACC.tabs.hideReviewBtn(".less-reviews-btn");
		});

		$e.on("click",".all-reviews-btn",function(e){
			e.preventDefault();
			ACC.tabs.showReviewsAction("allreviews");
			ACC.tabs.hideReviewBtn(".all-reviews-btn");
			ACC.tabs.showReviewBtn(".less-reviews-btn");
		});

		$e.on("click",".less-reviews-btn",function(e){
			e.preventDefault();
			ACC.tabs.showReviewsAction("reviews");
			ACC.tabs.hideReviewBtn(".less-reviews-btn");
			ACC.tabs.showReviewBtn(".all-reviews-btn");
		});

		$(document).on("click", '.js-writeReviewTab', function(e){
			e.preventDefault();
			tabs.showAccessibleTabSelector($(this).attr("href"));
			$(".js-review-write").show();
			$('#reviewForm input[name=headline]').focus();
		});

		$(document).on("click",".js-review-write-toggle",function(e){
			e.preventDefault();
			if($(".js-review-write:visible").length<1){
				$(".js-review-write").show();

			}else{
				$(".js-review-write").hide();
			}
		});

		$(document).on("click",".js-openTab",function(){
			tabs.showAccessibleTabSelector($(this).attr("href"));
		});
		/* Contentsquare */
		$(document).ready(function (){
			$('#tabdetails').on("click",function (){
				ACC.track.contentsquareAPVTracking("product-tab-details");
			});
		});
		$(document).on("click","#tabreview",function (){
			ACC.track.contentsquareAPVTracking("product-tab-reviews");
		});
		$(document).on("click","#tabfeatures",function (){
			ACC.track.contentsquareAPVTracking("product-tab-specs");
		})
		/* Contentsquare */

	},

	showReviewsAction: function (s)
	{
		$.get($("#reviews").data(s), function (result){
			$('#reviews').html(result);
			if($(".js-ratingCalc").length > 0){
				ACC.ratingstars.bindRatingStars();
			}
			ACC.tabs.showingAllReviews();
		});

	},

	hideReviewBtn: function (btnClass){

		btnClass = (btnClass == undefined)? ".less-reviews-btn" : btnClass;
		$(btnClass).hide();

	},

	showReviewBtn: function (btnClass){
		$(btnClass).show();

	},

	showingAllReviews: function()
	{
		var isShowingAllReviews = $("#showingAllReviews").data("showingallreviews");
		if(isShowingAllReviews){
			ACC.tabs.hideReviewBtn(".all-reviews-btn");
		}else {
			ACC.tabs.showReviewBtn(".all-reviews-btn");
		}
	},

	determineToDisplayReviews: function ()
	{
		if(location.hash == "#tabreview"){
			ACC.tabs.showReviewsAction('reviews');
		}
		if($('#accessibletabscontent0-2').length){
			$('#accessibletabscontent0-2').on('click', function(){
				ACC.tabs.showReviewsAction('reviews');
			});
		}
	},

	loadVariantFeatures: function ()
	{

		var productCode = $("#accessibletabscontent0-1").data('product');
		var url = ACC.config.encodedContextPath + '/p/loadFeatures';

		var options = {
			'productCode': productCode
		};

		$.ajax({
			url: url,
			async: true,
			data: options,
			dataType: "html",
			success: function (data)
			{
				$(".product-classifications").html($(data).html());
			}
		});

	},
	determineToDisplaySpecifications: function ()
	{

		if($('#accessibletabscontent0-1').length)
		{
			$('#accessibletabscontent0-1').on('click', function(){
				ACC.tabs.loadVariantFeatures();
			});
		}
		if($('#accessibletabsnavigation0-1').length)
		{
			$('#accessibletabsnavigation0-1').on('click', function(){
				ACC.tabs.loadVariantFeatures();
			});
		}
	},

};
